module.exports = {
      id: "text-usage",
      viewBox: "0 0 18.361 15.287",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#text",
      toString: function () {
        return this.url;
      }
    }